"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsubscribeEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class UnsubscribeEvent extends abstract_event_1.AbstractEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'unsubscribe';
    }
    getData() {
        var _a, _b, _c;
        return Object.assign({ email: this.config.email, list: (_a = this.config.list) !== null && _a !== void 0 ? _a : '', allow_marketing: this.config.allow_marketing, allow_sms_marketing: this.config.allow_sms_marketing, allow_policy: this.config.allow_policy, language: (_b = this.config.language) !== null && _b !== void 0 ? _b : '', source: (_c = this.config.source) !== null && _c !== void 0 ? _c : '' }, (this.config.eventId ? { eventId: this.config.eventId } : {}));
    }
}
exports.UnsubscribeEvent = UnsubscribeEvent;
//# sourceMappingURL=unsubscribe.event.js.map